import React from "react";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import snackbarStyles from "./snackbarStyles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { HashLink as Link } from "react-router-hash-link";
import { IconButton, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiLink from "@mui/material/Link";

export type CustomSnackbarProps = {
  buttonText?: string;
  buttonType?: "link" | "function";
  buttonLink?: string;
  buttonTarget?: string;
  buttonFunction?: () => void;
  isNonInteractive?: boolean;
  linkIsExternal?: boolean;
};

export const CustomSnackbar = React.forwardRef<HTMLDivElement, CustomSnackbarProps & CustomContentProps>(
  (
    {
      message = "Änderung wurde gespeichert",
      buttonText = "Rückgängig",
      buttonType = "link",
      buttonLink,
      buttonTarget = "_blank",
      buttonFunction,
      isNonInteractive = false,
      linkIsExternal = false,
    },
    ref
  ) => {
    const { closeSnackbar } = useSnackbar();
    return (
      <SnackbarContent ref={ref}>
        <Paper sx={snackbarStyles.assignedUserToast}>
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid sx={isNonInteractive ? snackbarStyles.message : undefined} size={isNonInteractive ? 10 : 6}>
              {message}
            </Grid>
            {!isNonInteractive && (
              <>
                <Grid sx={snackbarStyles.alignRight} size={4}>
                  {buttonType === "link" && buttonLink && (
                    <Button
                      component={linkIsExternal ? MuiLink : Link}
                      sx={snackbarStyles.revertButton}
                      href={buttonLink}
                      to={buttonLink}
                      target={buttonTarget}
                    >
                      {buttonText}
                    </Button>
                  )}
                  {buttonType === "function" && buttonFunction && (
                    <Button sx={snackbarStyles.revertButton} onClick={buttonFunction}>
                      {buttonText}
                    </Button>
                  )}
                </Grid>
              </>
            )}
            <Grid sx={snackbarStyles.alignRight} size={2}>
              <IconButton
                onClick={() => {
                  closeSnackbar();
                }}
                size="large"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Paper>
      </SnackbarContent>
    );
  }
);
